<ion-header class="ion-hide-lg-up">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title *ngIf="!(noTracker | async)">{{ selectedName | async }}</ion-title>
    <ion-spinner
      *ngIf="loadingDailyRoutes || (isWebsocketSlow$ | async)"
      class="title-bar-spinner"
      slot="end"></ion-spinner>
    <ion-buttons slot="end">
      <ion-button (click)="setMapType()" *ngIf="!(noTracker | async) && !(isWebSocketDisconnected$ | async)">
        <ion-icon src="/assets/icon/layers.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div id="map_canvas" [hidden]="(noTracker | async) || (isWebSocketDisconnected$ | async)">
    <ion-spinner class="page-loading-spinner" *ngIf="firstLoad"></ion-spinner>
  </div>

  <!-- NO TRACKER (NO MAP) -->
  <ng-container
    *ngIf="!(isWebSocketReconnecting$ | async) && ((noTracker | async) || (isWebSocketDisconnected$ | async))">
    <ion-grid *ngIf="!(isWebSocketDisconnected$ | async) else nosocket" class="ion-padding-top ion-margin-top">
      <ion-row>
        <ion-col size="10" offset="1" class="ion-text-center">
          <img class="ion-padding-bottom app-icon-only" src="assets/icon/icon-only.png" />
          <h1>{{'WELCOME' | translate}}</h1>
          <ng-container *ngIf="!hasPendingInvitations">
            <p>{{'ADD_YOUR_FIRST_TRACKER' | translate:{brandName: brandName} }}</p>
            <ion-button
              color="secondary"
              routerLink="/add-bike"
              [state]="{ isFirstBike: true }"
              [replaceUrl]="true"
              class="ion-margin-bottom"
              id="button-createtracker-start">
              {{'ADD_TRACKER' | translate}}
            </ion-button>
          </ng-container>
          <p>{{'FIRST_BIKE_INVITATION_LIST_DESCRIPTION' | translate}}</p>
          <ng-container *ngIf="hasPendingInvitations">
            <ion-item *ngFor="let inv of pendingInvitations" button detail="false">
              <ion-icon slot="start" name="person-circle" ios="person-circle-outline" color="primarycontrast"></ion-icon>
              <ion-label>
                <h2>{{inv.sharerEmail}}</h2>
                <p>{{'VALID_UNTIL' | translate:{date: (inv.invitationExpiresAt | date)} }}</p>
              </ion-label>
            </ion-item>
          </ng-container>

          <p>{{'FIRST_BIKE_INVITATION_REMINDER' | translate}}</p>

          <h4>{{'BUY_TRACKER' | translate}}?</h4>
          <p>{{'BUY_YOUR_FIRST_TRACKER' | translate:{brandName: brandName} }}</p>
          <ion-button color="secondary" (click)="openShop()">
            {{'POWUNITY_SHOP' | translate:{brandName: brandName} }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>

  <!-- NO SOCKET CONNECTION -->
  <ng-template #nosocket>
    <ion-grid class="ion-padding-top ion-margin-top">
      <ion-row>
        <ion-col size="10" offset="1" class="ion-text-center">
          <h1>{{'ERROR' | translate}}</h1>
          <p>{{'SOCKET_CONNECTION_ERROR' | translate}}</p>
          <ion-button color="secondary" (click)="retrySocketConnection()">{{'RETRY' | translate}}</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-template>

  <ng-container
    *ngIf="(isAnyTrackerSelected$ | async) && (hasSufficientSubscription$ | async) && !(isWebSocketDisconnected$ | async)">
    <!-- MAP LAYER BUTTON -->
    <ion-fab slot="fixed" vertical="top" [horizontal]="platform.is('ios') ? 'start' : 'end'" class="ion-hide-md-down">
      <ion-fab-button color="light" size="small" (click)="setMapType()">
        <ion-icon src="/assets/icon/layers.svg"></ion-icon>
      </ion-fab-button>
    </ion-fab>

    <!-- SPEED -->
    <ion-fab
      slot="fixed"
      vertical="top"
      *ngIf="showSpeed"
      [horizontal]="platform.width() >= 992 ? 'center' : (platform.is('ios') ? 'start' : 'end')">
      <ion-chip color="dark">
        <ion-icon name="speedometer" ios="speedometer-outline"></ion-icon>
        <ion-label id="label-map-speed">{{ selectedSpeed | async }} {{ unitUtil.velocityDefault }}</ion-label>
      </ion-chip>
    </ion-fab>

    <!-- STATS -->
    <ion-fab slot="fixed" vertical="bottom" horizontal="start" *ngIf="!(selectedDisabled | async)">
      <div class="stats-container">
        <ion-chip color="primary" *ngIf="selectedDailyDistance > 1" (click)="showDailyDistanceToast()">
          <ion-icon name="bar-chart" ios="bar-chart-outline"></ion-icon>
          <ion-label>{{ selectedDailyDistance }} {{ unitUtil.distanceDefault }}</ion-label>
        </ion-chip>

        <ion-chip
          [color]="(selectedBatteryLevel | async) === 0 ? 'danger' : ((selectedOnline | async) ? 'primary' : 'medium')"
          (click)="showBatteryEstimation()">
          <ion-icon [src]="selectedBatteryIcon | async" [class.chip-icon-only]="(selectedCharging | async)"></ion-icon>
          <ion-label *ngIf="selectedBatteryLevel && !(selectedCharging | async)">
            <span *ngIf="!(selectedOnline | async)">~</span>
            {{selectedBatteryLevel | async}}%
          </ion-label>
        </ion-chip>
      </div>
    </ion-fab>

    <!-- GUARD BUTTON -->
    <div class="guard-button-container">
      <pow-icon-toggle
        id="guard-button"
        class="guard-button"
        [checked]="selectedGuarded | async"
        [danger]="selectedAlarm | async"
        [loading]="busy"
        leftIcon="lock-open-outline"
        rightIcon="lock-closed-outline"
        (click)="toggleAlarm$.next()"></pow-icon-toggle>
    </div>

    <!-- LOCATION BUTTON -->
    <ion-fab
      slot="fixed"
      [vertical]="isWeb ? 'top' : 'bottom'"
      [horizontal]="isWeb ? 'start' : 'end'"
      *ngIf="!infoWindowOpen">
      <ion-fab-button color="light" size="small" (click)="getUserLocation()">
        <ion-icon
          id="noLocationPermission"
          *ngIf="!locationPermission"
          src="/assets/icon/location_disabled.svg"></ion-icon>
        <ion-icon *ngIf="locationPermission" name="locate" ios="locate-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>

    <!-- NAVIGATION BUTTON -->
    <ion-fab
      slot="fixed"
      vertical="bottom"
      horizontal="end"
      *ngIf="(platform.is('android') || platform.is('ios')) && infoWindowOpen">
      <ion-fab-button color="light" size="small" (click)="openNavigator()">
        <ion-icon name="navigate" ios="navigate-outline"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  </ng-container>
</ion-content>
<ng-container *ngIf="isAnyTrackerSelected$ | async">
  <ion-footer
    *ngIf="!(hasSufficientSubscription$ | async) || (selectedGpsDisabled | async) || (selectedDisabled | async)">
    <ion-item
      *ngIf="!(hasSufficientSubscription$ | async)"
      detail="true"
      routerLink="/subscription"
      routerDirection="forward">
      {{ 'SUBSCRIPTION_EXPIRED' | translate }}
    </ion-item>
    <ion-item
      *ngIf="(selectedGpsDisabled | async) || (selectedDisabled | async)"
      detail="true"
      routerLink="/settings"
      routerDirection="forward">
      {{ 'TRACKING_DISABLED_MAPHINT' | translate }}
    </ion-item>
  </ion-footer>
</ng-container>
